import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../shared/shared.service';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import { BehaviorSubject, of } from 'rxjs';
import { User } from '../user';
import { JsonpClientBackend } from '@angular/common/http';
import { concat } from 'rxjs-compat/operator/concat';
 
@Injectable()
export class AuthService { 
    user: User = new User ();
    private controller: string = "Security";
    private isloggedIn: boolean;
    private userName:string;
    private userSubject: BehaviorSubject<User>;
 
    constructor(private sharedService: SharedService, private router: Router, private spinner: NgxSpinnerService, private toastr: ToastrService ) {
        this.isloggedIn=true;
        this.userSubject = new BehaviorSubject<User>(
        JSON.parse(localStorage.getItem('currentUser'))
        );
    }
 
    public get userValue(): User {
        return this.userSubject.value;
    }

    getUserAccountId(id: string)
    {
        var accId = "AC42ACCD-D8F5-4A83-8464-0C4C4BD79FC4";
        this.sharedService.get<User>(`${this.controller}/GetUserAccountId/${accId}`, false).subscribe(
            res => {
            var aId = res;
            var currentAccountId = aId;
            console.log(currentAccountId);
            localStorage.setItem('currentAccountId', JSON.stringify(accId));
            //console.log("this account id is " + currentAccountId);
            console.log('this account id is ', res);
            },
            err => {
              console.log('error', err);
           },
            () => { this.spinner.hide(); }
          )
    }

    login(userName: string, userPassword: string) {
       // username = "admin";
        //Assuming users are provided the correct credentials.
        //In real app you will query the database to verify.
        this.isloggedIn=true;
        this.isUserLoggedIn() === true;
        this.userSubject = new BehaviorSubject<User>(
        JSON.parse(localStorage.getItem('currentUser')),
        );
        this.user.userName = userName;
        this.user.userPassword = userPassword;
        var thisUserRoleName = this.user.userName;
        console.log("current user name: " + thisUserRoleName); 
        this.sharedService.post<User>(this.user, `${this.controller}/AdminLogin`, false)
        .subscribe(
         res => {
            if (res == null)
            {
              this.toastr.error("لا يمكن الدخول");
           }
          else
          {
            this.isloggedIn=true;
            var returnedUerRoleTitle = res;
            var currentUser = returnedUerRoleTitle;
            console.log("this role is: " + returnedUerRoleTitle);
            localStorage.setItem('currentUser', JSON.stringify(currentUser));
            
            console.log("this username is: " + this.user.userName);

      this.getUserAccountId(res.userId);
     
            this.userSubject.next(currentUser);
            // console.log("the local storage user: " + localStorage.setItem('currentUser', JSON.stringify(currentUser)));
            this.router.navigate(['/articles']);
            this.isUserLoggedIn() === true;
            this.toastr.success("تم تسجيل الدخول");
            return currentUser;
          }
      },
      err => {
        console.log(err);
      },
      () => { this.spinner.hide(); }
    )
        return of(this.isloggedIn);
    }

    logout() {
        this.isloggedIn = false;
        localStorage.removeItem('currentUser');
        this.userSubject.next(null);
    }
 
    isUserLoggedIn(): boolean {
        return this.isloggedIn;
    }
 
    isAdminUser():boolean {
        if (this.userName=='Admin') {
            return true; 
        }
        return false;
    }
    
    logoutUser(): void{
        this.isloggedIn = false;
    }
 
} 
